import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'UpdateVoohCampaignDetailsPayload'

export const UPDATE_VOOH_CAMPAIGN_DETAILS = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation updateVoohCampaignDetails(
    $id: ID!
    $mediaFormat: VoohMediaFormatEnum!
    $hourFrequency: Int
    $offer: VoohCampaignOfferEnum
    $organizationAttribute: VoohOrganizationAttributeUsage
    $mediaDuration: Int
  ) {
    updateVoohCampaignDetails(
      input: {
        id: $id
        mediaFormat: $mediaFormat
        hourFrequency: $hourFrequency
        offer: $offer
        organizationAttribute: $organizationAttribute
        mediaDuration: $mediaDuration
      }
    ) {
      voohCampaign {
        publishable
        id
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
